import type { GameState, MapDefinition, PathCell } from '../../model/gamestate/GameState';
import type { TileMapRenderer } from '../../renderer/tilemap/TileMapRenderer';
import type { PathTileAtlasId } from '../pathTileRegistry';
import { applyCanonicalPathTileEdit } from './pathTileLayers';

export interface SinglePathTileEdit {
  atlasId: PathTileAtlasId;
  x: number;
  y: number;
  cell: PathCell | null;
}

export function applySinglePathTileEdit(
  gameState: GameState,
  renderer: TileMapRenderer,
  edit: SinglePathTileEdit,
): void {
  const map = gameState.getMap();

  const tileOffset = (edit.y * map.width) + edit.x;
  const currentTile = map.tiles[edit.y]?.[edit.x];
  if (!currentTile) {
    return;
  }

  const nextLayers = applyCanonicalPathTileEdit(map.width, map.height, map.pathLayers, {
    atlasId: edit.atlasId,
    tileOffset,
    cell: edit.cell
      ? edit.cell.mode === 'autotile'
        ? {
          mode: 'autotile',
          surfaceTerrain: edit.cell.surfaceTerrain ?? currentTile.terrain,
        }
        : {
          ...edit.cell,
          surfaceTerrain: edit.cell.surfaceTerrain ?? currentTile.terrain,
        }
      : null,
  }, map.gridType);

  const nextMap: MapDefinition = {
    ...map,
    pathLayers: nextLayers,
  };
  gameState.setMap(nextMap, gameState.getCurrentMapId());
  renderer.refreshCurrentMap(nextMap);
}

export function applySinglePathBorderContinuationEdit(
  gameState: GameState,
  renderer: TileMapRenderer,
  edit: { atlasId: string; x: number; y: number; active: boolean },
): void {
  const map = gameState.getMap();
  const nextBorderContinuations = (map.pathBorderContinuations ?? []).filter((tile) => (
    !(tile.atlasId === edit.atlasId && tile.x === edit.x && tile.y === edit.y)
  ));
  if (edit.active) {
    nextBorderContinuations.push({
      atlasId: edit.atlasId,
      x: edit.x,
      y: edit.y,
    });
  }

  const nextMap: MapDefinition = {
    ...map,
    pathLayers: (map.pathLayers ?? []).map((layer) => ({ ...layer, data: [...layer.data] })),
    pathBorderContinuations: nextBorderContinuations,
  };
  gameState.setMap(nextMap, gameState.getCurrentMapId());
  renderer.refreshCurrentMap(nextMap);
}
